module.exports = __webpack_public_path__ + "img/grayDisabledDam.651505a1.svg";